'use client';

import clsx from 'clsx';
import { Logo } from 'components/logo';
import { useAtomValue } from 'jotai';
import { FocusableLink } from 'ui';
import {
  quotionBadgeUrlAtom,
  showQuotionBadgeAtom,
} from '../../../_components/design-state';

type QuotionBadgeProps = {
  hasLitePlus: boolean;
};

export function QuotionBadge({ hasLitePlus }: QuotionBadgeProps) {
  const showQuotionBadge = useAtomValue(showQuotionBadgeAtom);
  const quotionBadgeUrl = useAtomValue(quotionBadgeUrlAtom);
  let linkClass = '';
  let linkStyle = {};
  let containerClass = '';
  if (!hasLitePlus) {
    linkClass = 'fixed bottom-[20px] start-1/2 shadow-lg';
    linkStyle = {
      // --removed-body-scroll-bar-size to fix layout shift when select is open
      transform: `translateX(calc(-50% - var(--removed-body-scroll-bar-size, 0px) / 2))`,
    };
  } else if (showQuotionBadge) {
    containerClass = 'flex justify-start sm:justify-center -translate-y-12';
    linkClass = 'shadow-xs';
  } else {
    containerClass = 'hidden';
  }

  return (
    <div className={containerClass}>
      <FocusableLink
        className={clsx(
          linkClass,
          // Use fixed values to avoid affected by user's setting
          'inline-flex items-center gap-[8px] rounded-[8px] border bg-white px-[12px] py-[6px] text-gray-600 transition hover:bg-secondary hover:text-tertiary-hover dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300',
        )}
        style={linkStyle}
        href={quotionBadgeUrl || 'https://quotion.co'}
        aria-label="Made with Quotion"
        rel="nofollow"
      >
        {/* Fixed font size, don't scale with user's font size setting */}
        <span className="text-[14px] font-medium leading-[20px]">
          Made with
        </span>
        <Logo height={18} width={69} />
      </FocusableLink>
    </div>
  );
}
